export default "__VITE_ASSET__DrH7ptB8__"